import { render } from "./treeList.vue?vue&type=template&id=587eed2f&scoped=true"
import script from "./treeList.vue?vue&type=script&lang=js"
export * from "./treeList.vue?vue&type=script&lang=js"

import "./treeList.vue?vue&type=style&index=0&id=587eed2f&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-587eed2f"]])

export default __exports__